import classNames from 'classnames';
import React, { useState } from 'react';
import { useLocation } from 'wouter';
import { getUserByPhone } from '../api/user';
import { useQuery } from 'react-query';
import MemberScanner from './MemberScanner';
import MemberFound from './MemberFound';
import MemberNotFound from './MemberNotFound';
import Modal from './Modal';
import Loader from './Loader';
import Button from './Button';

interface MemberVerificationProps {}

const MemberVerification: React.FC<MemberVerificationProps> = () => {
  const [memberPhone, setMemberPhone] = useState<string>('');
  const [showPhoneInput, setShowPhoneInput] = useState<boolean>(false);
  const [showScanner, setShowScanner] = useState<boolean>(false);
  const [location, setLocation] = useLocation();
  const [open, setOpen] = useState<boolean>(false);

  const userQuery = useQuery(
    ['getUserByPhone', memberPhone],
    ({ queryKey }) => getUserByPhone(queryKey[1]),
    {
      enabled: false,
    }
  );

  const scanQrCode = () => {
    setShowScanner(true);
    setShowPhoneInput(false);
  };

  const inputPhone = () => {
    setShowPhoneInput(true);
    setShowScanner(false);
  };

  const onPhoneChange = (e: React.FormEvent<HTMLInputElement>) => {
    setMemberPhone(e.currentTarget.value);
  };

  const checkMemberPhone = (e: React.FormEvent) => {
    e.preventDefault();
    userQuery.refetch();
    setOpen(true);
  };

  return (
    <div>
      <form
        className={classNames(showPhoneInput ? '' : 'ceas-hidden', 'ceas-mb-5')}
        onSubmit={checkMemberPhone}
      >
        <div className="ceas-mt-1 ceas-flex ceas-rounded-md ceas-bg-gray-100 ceas-shadow-sm ceas-w-full md:ceas-w-1/2">
          <div className="ceas-relative ceas-bg-gray-100 ceas-py-3 ceas-px-6 ceas-flex ceas-items-stretch ceas-flex-grow focus-within:ceas-z-10">
            <input
              type="number"
              name="phone"
              value={memberPhone}
              onChange={onPhoneChange}
              className="focus:ceas-ring-primary-500 focus:ceas-border-primary-500 ceas-bg-gray-100 ceas-outline-none ceas-block ceas-w-full ceas-rounded-none ceas-rounded-l-md sm:ceas-text-sm ceas-border-gray-300"
              placeholder="Enter phone number"
              required
            />
          </div>
          <button
            type="submit"
            className="ceas--ml-px ceas-relative ceas-inline-flex ceas-items-center ceas-space-x-2 ceas-px-4 ceas-py-2 ceas-border ceas-border-gray-300 ceas-text-sm ceas-font-medium ceas-rounded-r-md ceas-text-white ceas-bg-primary-600 hover:ceas-bg-primary-700 focus:ceas-outline-none focus:ceas-ring-1 focus:ceas-ring-primary-500 focus:ceas-border-primary-500"
          >
            Submit
          </button>
        </div>
      </form>
      <Button theme="primary" onClick={scanQrCode}>
        Scan QR Code
      </Button>
      <span className="ceas-mx-2 ceas-underline">OR</span>
      <Button theme="primary" onClick={inputPhone}>
        Enter Phone
      </Button>
      <MemberScanner open={showScanner} setOpen={setShowScanner} />

      <Modal open={open} setOpen={setOpen}>
        {({ cancelButtonRef }) => (
          <>
            {userQuery.isLoading ? (
              <Loader />
            ) : userQuery.data ? (
              <MemberFound user={userQuery.data} />
            ) : (
              <MemberNotFound />
            )}
            <div className="ceas-mt-5 sm:ceas-mt-6 ceas-flex ceas-justify-between">
              <Button onClick={() => setOpen(false)} ref={cancelButtonRef}>
                Cancel
              </Button>
              {userQuery.data && (
                <Button
                  theme="primary"
                  onClick={() => setLocation(`/transactions/?member_id=${userQuery.data.id}`)}
                >
                  Continue
                </Button>
              )}
            </div>
          </>
        )}
      </Modal>
    </div>
  );
};

export default MemberVerification;
